import React from 'react';
import PropTypes from 'prop-types';

import AdminPagination from './Pagination';

const AdminFooter = ({
  itemsTotal,
  page,
  perPage,
  handleChangePage,
}) => (
  <div className="table-footer">
    <AdminPagination
      total={itemsTotal}
      page={page}
      perPage={perPage}
      handleChangePage={handleChangePage}
    />
  </div>
);

AdminFooter.propTypes = {
  itemsTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
};

export default AdminFooter;
